export default "__VITE_ASSET__fe68a87f__"